export default __webpack_public_path__ + "static/media/complete-arrow-right.74c2ad4d.svg";